/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const FlaskSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M16.5 2h-9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.47v2.795L3.246 17.818C2.397 19.798 3.849 22 6.003 22h11.934c2.154 0 3.606-2.202 2.758-4.182L15.97 6.795V4h.53a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5ZM9.97 6.897V4h4v2.897c0 .204.041.405.121.591l2.8 6.532-2.736.684a3 3 0 0 1-2.24-.32l-4.017-2.343 1.95-4.553a1.5 1.5 0 0 0 .122-.59Zm-2 10.603c0 .9.6 1.5 1.5 1.5s1.5-.6 1.5-1.5-.6-1.5-1.5-1.5-1.5.6-1.5 1.5ZM14 13c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1Z" /></svg>);
const FlaskSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={FlaskSolidBase} {...rest} ref={ref} />);
export default FlaskSolid;